import * as React from "react"
import { useState, useEffect, useMemo,useCallback } from "react"
import { useTranslation } from "react-i18next"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import Form from "@bappweb/form"
import Button from "@bappweb/button"
import { Sizes, useDeviceSize } from "@bappweb/provider"
import Page from "@components/globalmodules/page"
import BigLogoAkbank from "@components/globalmodules/logo/index-bigLogo"
import "./style.scss"
import { useHistory } from "react-router-dom"
import Link from "@bappweb/link"
import { SendSMSService } from "@config/axios/sendSMSService"
import { API_URLS } from "../../../constants/api/index"
import { CompositeResetPassword } from "@config/axios/compositeResetPassword"
import { CaptchaCallService } from "@config/axios/captchaCallService"
import TextField from "@bappweb/textfield"
import { required } from "@bappweb/utils"

let responseData: {  retCode: number, retMsg: string } = {
  retCode: 0,
  retMsg: ""
}



const SftpForgotPasswordMsg = (props) => {
  const { t } = useTranslation()
  const size = useDeviceSize()
  const history = useHistory()


  let passUserName = props.location.state.passData.userName;
  let passPhoneNumber = props.location.state.passData.gsmNo;
  let passNewPsw = props.location.state.passData.newPsw;
  let mail = props.location.state.passData.mail;
  let phone = props.location.state.passData.phone;
  let captchaId= "";
  let captchaText= "";

  let pageMEssageEN="Your password has been sent";

  const [serviceReturnCode, setServiceRetCode] = useState("");
  const [serviceReturnMsg, setServiceRetMsg] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [captchaResp, setCaptchaResp] = useState({ id: "" });
  const [base64Image, setbase64Image] = React.useState("");
  const [pageMessage, setpageMessage] = React.useState("Şifreniz telefonunuza gönderilmiştir.");
  const [captchafield, setcaptchafield] = React.useState("");


  const [delay, setDelay] = useState(+"180"); 
  const minutes = Math.floor(delay / 60);
  const seconds = Math.floor(delay % 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setDelay(delay - 1);
    }, 1000);

    if (delay === 0) {
      clearInterval(timer);
      inputChange();
      
    }

    return () => {
      clearInterval(timer);
    };
  });

  useEffect(() => {
    //#region Captcha Call
    const fetchData = async () => {
      const data = await CaptchaCallService();
     
      setCaptchaResp(data);
      ConvertBase64ToImage(data);
    }

    fetchData();

    //#endregion

  }, []);
  const handleSubmit = React.useCallback((e, data) => {
    
    window.location.href=API_URLS.FTP_URL;

  }, [])

 

  const handleChange = useCallback((e) => {
    const name = e.target.name
    const value = e.target.value
    
    switch (name) {
    case "securityCode":
      setcaptchafield(value)


    break;
    default:
    break;
    }
    }, [])

  const handleError = React.useCallback((e, errors) => {
    console.info(JSON.stringify(errors, void 0, 2))
  }, [])

  function ConvertBase64ToImage(respData) {
    setbase64Image(respData.base64Contents);
  }

  const handleReSendSms = React.useCallback(async () => {
 debugger;
    responseData = await CompositeResetPassword({ id: captchaResp.id , entry: captchafield,userId: passUserName, mail:mail,phone:phone});
   
    setServiceRetMsg(responseData.retMsg)
   

    if (responseData.retCode !== 0 ) {
      setpageMessage (t(responseData.retMsg));
      
      const passData = { userName: passUserName, gsmNo: passPhoneNumber, newPsw: passNewPsw, pageMessage: pageMessage,phone:phone, mail:mail };    
      history.push('/sftp-forgotPassword-msg', { passData });
     
    }
    else {
      setpageMessage ("Şifreniz telefonunuza gönderilmiştir");
      setServiceRetCode(responseData.retCode.toString());
      setServiceRetMsg(t(responseData.retMsg));
    }



  }, [history, captchaResp.id , captchafield, passUserName, serviceReturnCode, serviceReturnMsg,phone, t])

  const inputChange = () => {
    handleReloadCaptchaClick();
    setIsFormValid(true);
    setDelay(180);
 
  };

  const handleSendSms = React.useCallback(async () => {

    setIsFormValid(false); 
    handleReSendSms();
    setDelay(180); 
  
  }, [handleReSendSms])

 
  const handleReloadCaptchaClick = React.useCallback(async () => {
    
    const data = await CaptchaCallService();
    setCaptchaResp(data);
    captchaId=data.id;
    ConvertBase64ToImage(data);

  }, [])
  const main = useMemo(() => {
    return (

      <Block className="bapp-page-login-main">
        <Block className="bapp-page-login-main-wrapper">
          <Element type="h1" style={{ fontSize: "24px", fontFamily: "Campton", textAlign: "center", fontWeight: "550" }}>{t(pageMEssageEN)}</Element>
          <Element className="sftp-header" style={{ fontSize: "14px", fontFamily: "Campton", textAlign: "center", fontWeight: "475", lineHeight: "20px" }} >{t(pageMessage)}</Element>

          <Form onSubmit={handleSubmit} onError={handleError} grid={false}>

            <Button text={t("Login")} type="submit" fullWidth />
          </Form>
          
          <Form onSubmit={handleSendSms}  onChange={handleChange} onError={handleError}  grid={false}>
          {isFormValid && 
          <div style={{ display: "flex" }}>
          
              <TextField
                
                label={t("GÜVENLİK KODU")}
                placeholder={t("Güvenlik Kodun")}
                type="text"
                name="securityCode"
                validations={[required(t("validation.required"))]}
              />
          
          
              <span style={{ width: "30%", paddingTop: "13%" }}>
                <img src={"data:image/png;base64," + base64Image} width={"80%"} alt="" />
              </span>
              <span style={{ width: "10%", paddingTop: "13%" }}>
                <img src="../img/reload_icon.png" alt="logo" height={"40%"} onClick={handleReloadCaptchaClick} />
              </span>
            </div>
  }
          <div>           
          {isFormValid && <Link onClick={handleSendSms} type="submit" >{t("Tekrar Gönder")}</Link>}
            {!isFormValid && <Link disabled={true}  >{t("Tekrar Gönder (0" + minutes + ":" + (seconds <= 9 ? ("0" + seconds):seconds ) + ")")}</Link>}        
          </div>
          
          </Form>
          <Link style={{ marginLeft: "10px" }} onClick={()=> history.push("/")}>
              {t("Şifre İşlemleri")}
            </Link>

        </Block>
      </Block>
    )
  }, [handleError, handleSubmit, t, base64Image,passPhoneNumber, minutes, seconds, isFormValid, handleSendSms,history,handleReloadCaptchaClick])

  return (
    <Page className="bapp-page-login" container={false} footer={false}>
      {size !== Sizes.xs ? (
        <>
          <Block className="" />
          <Block className="bapp-page-login-desktop-wrapper bapp-container">
            <Block>
              <BigLogoAkbank />

              <Image path={"/img/svg/mail-send.svg"} fallbackText={t("Oriented Woman")} />
              <Element className="sftp-header" style={{ fontSize: "34px", color: "black" }} type="h2" >{t("Your files are safe with the file sharing center")}</Element>
              <Element style={{ fontSize: "23px", color: "black" }}>{t("Akbank güvenli dosya transferi ile FTP dosyalarını güvenli bir şekilde aktarabilirsiniz.")} </Element>
            </Block>
            {main}
          </Block>
        </>
      ) : (
        main
      )}
    </Page>
  )
}

export default SftpForgotPasswordMsg
